<template>
  <component :is="type" :class="['paragraph', variation]">
    <slot />
  </component>
</template>

<script>
export default {
  name: "Paragraph",
  status: "prototype",
  release: "3.5.0",
  props: {
    /**
     * The html element used for the text.
     * `p, span`
     */
    type: {
      type: String,
      default: "p",
      validator: (value) => {
        return value.match(/(p|span)/);
      },
    },
    /**
     * Style variation to give additional meaning.
     * `intro, small, medium, large`
     */
    variation: {
      type: String,
      default: "medium",
      validator: (value) => {
        return value.match(/(medium|intro|large|small|xxl|xl|l|regular|m|s|xs)/);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../design-system/assets/tokens/tokens";
.paragraph {
  @include reset;
  @include stack-space($space-m);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: color 0.3s ease;
  font-family: $font-text;
  font-weight: $weight-normal;
  font-size: 18px;
  line-height: $line-height-m;
  color: $color-iloq-gray-dark;
  a {
    color: $color-iloq-blue-light;
    text-decoration: none;
    &:hover {
      color: $color-iloq-blue-dark;
    }
  }
  &.intro {
    @include stack-space($space-m);
    font-family: $font-heading;
    font-weight: $weight-light;
    font-size: 20px;
  }
  &.large {
    font-size: $size-l;
  }
  &.small {
    font-size: $size-s;
  }
  &.xxl {
    @include stack-space($space-m);
    font-size: $size-iloq-xxl;
  }
  &.xl {
    @include stack-space($space-m);
    font-size: $size-iloq-xl;
  }
  &.l {
    @include stack-space($space-s);
    font-size: $size-iloq-l;
  }
  &.m {
    @include stack-space($space-s);
    font-size: $size-iloq-m;
  }
  &.regular {
    @include stack-space($space-xs);
    font-size: $size-iloq-regular;
  }
  &.s {
    @include stack-space($space-xs);
    font-size: $size-iloq-s;
  }
  &.xs {
    @include stack-space($space-xxs);
    font-size: $size-iloq-xs;
  }
}
</style>
